import { AbstractControl } from '@angular/forms';
import { DateFormatUtils } from '../../shared/utils/date-format.utils';
import { Loinc } from './covid-test-user-form/loinc';

export class CustomValidators {

    static loincValidator(control: AbstractControl): { [key: string]: any } | null {
        return !(Loinc.loincValues.indexOf(control.value) > -1) ? { invalidLoinc: true } : null;
    }

    static dateValidator(control: AbstractControl): { [key: string]: any } | null {
        const today = new Date().getTime();
        const parts = control.value.indexOf('/') > -1 ? DateFormatUtils.formatDate(control.value).split('-') : control.value.split('-')
        const newDate = new Date(parts[0], parts[1] - 1, parts[2]);
        return (newDate.getTime() > today) ? { invalidDate: true } : null;
    }


}